import { render } from "./ModalVerify.vue?vue&type=template&id=54d6e01b&scoped=true"
import script from "./ModalVerify.vue?vue&type=script&lang=js"
export * from "./ModalVerify.vue?vue&type=script&lang=js"

import "./ModalVerify.vue?vue&type=style&index=0&id=54d6e01b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d6e01b"]])

export default __exports__